import zPage from '../Page/page.vue';
import comList from '../../components/com-list.vue';
export default{
    name:'HomeList',
    data(){
        return{
            page:{
                targetPage:1,
                pageSize:20,
                totalPage:100,
                type:2,
            },
            column:'',
            breadTitle:'重要通知',
            list:[],
        }
    },
    components:{
        zPage,
        comList,
    },
    created(){
        this.getData();
    },
    methods:{
        getData(){
            this.breadTitle=this.$route.query.type;
            var url=this.breadTitle=="重要通知"?this.api.getImportNoticePage:this.api.getNewsInfoPage;
            var body={
                pageNumber:this.page.targetPage-1,
                pageSize:this.page.pageSize,
            };
            this.get(url,body).then(res=>{
                this.page.totalPage=res.data.totalElements;
                this.list=res.data.list;
                for(var i =0; i < this.list.length;i++){
                    this.list[i].createDate=this.list[i].createDate.substring(0,10)
                }
            }).catch();
        },
        getDetail(type,id){
            this.$router.push({path:'/homeDetail',query:{type:type,id:id}});
        },
        // changePage (val, type) {
        //     if (type) {
        //         this.page.targetPage = 0;
        //         this.page.pageSize = val;
        //     } else {
        //         this.page.targetPage = val;
        //     }
        //     this.getData();
        // },
    }
}